export default __webpack_public_path__ + "static/nbox-logo.242aa0f8.svg";